import { FunctionComponent, useEffect, useState } from 'react';
import SelectInput, { SelectDataType } from './SelectInput';
import TreemapGd, { FuenteGd } from './TreemapGd';
import { getUncatchEndpointData } from '../utils/request';

const VALOR_TODAS = '__TODAS__';
const OPCION_TODAS: SelectDataType = { value: VALOR_TODAS, name: 'Todas las regiones' };

const Bloque2ATreemapGd: FunctionComponent<{
  fuente: FuenteGd;
  titulo: string;
}> = ({ fuente, titulo }) => {
  const [regiones, setRegiones] = useState<SelectDataType[]>([OPCION_TODAS]);
  const [regionSel, setRegionSel] = useState<string>(VALOR_TODAS);

  useEffect(() => {
    let cancelado = false;
    const fetchRegiones = async () => {
      try {
        const res = await getUncatchEndpointData({
          endpoint: 'estadisticas-gd/regiones',
          query: { fuente }
        });
        if (cancelado) return;
        const lista: string[] = (res && res.regiones) || [];
        setRegiones([OPCION_TODAS, ...lista.map((r) => ({ value: r, name: r }))]);
      } catch (err) {
        if (cancelado) return;
        console.error(err);
        setRegiones([OPCION_TODAS]);
      }
    };
    fetchRegiones();
    return () => {
      cancelado = true;
    };
  }, [fuente]);

  const regionParam = regionSel === VALOR_TODAS ? null : regionSel;

  return (
    <div className='estadisticas-gd-bloque2a-fuente'>
      <div className='estadisticas-gd-fuente-header'>
        <h3 className='estadisticas-gd-fuente-titulo'>{titulo}</h3>
        <div className='estadisticas-gd-fuente-filtros'>
          <label className='estadisticas-gd-filtro-label'>Región</label>
          <SelectInput
            label='Selecciona Región'
            name={`region-${fuente}-treemap`}
            id={`region-${fuente}-treemap`}
            value={regionSel}
            onChange={(e) => setRegionSel(e.target.value)}
            options={regiones}
          />
        </div>
      </div>

      <div className='treemap-gd-par'>
        <div className='treemap-gd-par-item'>
          <h4 className='treemap-gd-par-titulo'>Cantidad de proyectos</h4>
          <TreemapGd fuente={fuente} region={regionParam} metrica='cantidad' altura={300} />
        </div>
        <div className='treemap-gd-par-item'>
          <h4 className='treemap-gd-par-titulo'>Capacidad instalada</h4>
          <TreemapGd fuente={fuente} region={regionParam} metrica='capacidad' altura={300} />
        </div>
      </div>
    </div>
  );
};

export default Bloque2ATreemapGd;
